module.exports = __webpack_public_path__ + "img/slide_001_h4.2b4eb6d1.jpg";